module.exports = __webpack_public_path__ + "img/icon-student@2x.d333af5.png";